export default __webpack_public_path__ + "static/media/img_03.47b02f33.jpg";